import './Loading.scss'
import template from './Loading.vhtml';

export default {
	name: 'Loading',
	template: template,
	props: {
		isLoading: {
			type: Boolean,
			default: true,
		},
		isBlue: {
			type: Boolean,
			default: false,
		},
		hasBg: {
			type: Boolean,
			default: true,
		},
	},
	data: () => ({}),
	computed: {},
	methods: {},
};
